<template>
  <div class="bg-transparent p-4 py-5 row text-center" style="background-color: transparent;">
    <div class="container mx-auto col-11 glass-container" style="backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(12px);">
      <div class="row">
        <div class="col-12">
          
          <!-- Header Section -->
          <div class="text-center mb-5">
            <div class="d-flex align-items-center justify-content-center mb-4">
              <div class="header-line"></div>
              <span class="badge-label px-4 py-2 mx-3 fw-bold">
                UNIVERSITY OF CHITTAGONG Admission 2026-2027
              </span>
              <div class="header-line"></div>
            </div>
            
            <h1 class="display-1 fw-black mb-4 gradient-title">
              Registration Starts In
            </h1>
            
            <div class="d-flex align-items-center justify-content-center gap-2 mb-4">
              <div class="divider-line-lg"></div>
              <div class="divider-line-sm"></div>
            </div>
          </div>

          <!-- Countdown Section -->
          <div class="row g-4 g-lg-5 justify-content-center">
            
            <!-- Days -->
            <div class="col-6 col-md-3 text-center">
              <div class="countdown-wrapper floating-1">
                <div class="glow-effect purple-glow"></div>
                <div class="countdown-border purple-border">
                  <div class="countdown-inner bg-white">
                    <div class="display-1 fw-black gradient-number">
                      {{ formatNumber(timeLeft.days) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="label-text mt-4">DAYS</div>
            </div>

            <!-- Hours -->
            <div class="col-6 col-md-3 text-center">
              <div class="countdown-wrapper floating-2">
                <div class="glow-effect pink-glow"></div>
                <div class="countdown-border pink-border">
                  <div class="countdown-inner bg-white">
                    <div class="display-1 fw-black gradient-number">
                      {{ formatNumber(timeLeft.hours) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="label-text mt-4">HOURS</div>
            </div>

            <!-- Minutes -->
            <div class="col-6 col-md-3 text-center">
              <div class="countdown-wrapper floating-3">
                <div class="glow-effect orange-glow"></div>
                <div class="countdown-border orange-border">
                  <div class="countdown-inner bg-white">
                    <div class="display-1 fw-black gradient-number">
                      {{ formatNumber(timeLeft.minutes) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="label-text mt-4">MINUTES</div>
            </div>

            <!-- Seconds -->
            <div class="col-6 col-md-3 text-center">
              <div class="countdown-wrapper floating-4">
                <div class="glow-effect red-glow"></div>
                <div class="countdown-border red-border">
                  <div class="countdown-inner bg-white">
                    <div class="display-1 fw-black gradient-number">
                      {{ formatNumber(timeLeft.seconds) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="label-text mt-4">SECONDS</div>
            </div>

          </div>

          <!-- Decorative Dots -->
          <div class="d-flex justify-content-center gap-2 mt-5">
            <div class="pulse-dot purple-dot"></div>
            <div class="pulse-dot pink-dot"></div>
            <div class="pulse-dot orange-dot"></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeLeft: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      interval: null
    }
  },
  mounted() {
    this.targetDate = new Date("2027-12-01T00:00:00+06:00");

    this.updateCountdown();
    this.interval = setInterval(this.updateCountdown, 1000);
    },
  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    updateCountdown() {
        const now = new Date();
        const diff = this.targetDate - now;

        if (diff <= 0) {
        this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        clearInterval(this.interval);
        return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        this.timeLeft  = { days, hours, minutes, seconds };
    },
    formatNumber(num) {
      return String(num).padStart(2, '0');
    }
  }
}
</script>

<style scoped>

.glass-container {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 24px;
  padding: 3rem 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
/* Header Styling */
.header-line {
  height: 1px;
  width: 48px;
  background: linear-gradient(to right, transparent, #9333ea, transparent);
}

.badge-label {
  font-size: 0.75rem;
  letter-spacing: 0.2em;
  background: linear-gradient(135deg, #9333ea, #ec4899);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.gradient-title {
  background: linear-gradient(135deg, #9333ea 0%, #ec4899 50%, #f97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-family: 'Robota', 'Trebuchet MS', sans-serif;
  line-height: 1.2;
}

.divider-line-lg {
  height: 4px;
  width: 64px;
  background: linear-gradient(to right, #9333ea, #ec4899);
  border-radius: 2px;
}

.divider-line-sm {
  height: 4px;
  width: 64px;
  background: linear-gradient(to right, #ec4899, #f97316);
  border-radius: 2px;
}

/* Countdown Box Styling */
.countdown-wrapper {
  position: relative;
  display: inline-block;
}

.glow-effect {
  position: absolute;
  inset: 0;
  opacity: 0.2;
  filter: blur(40px);
  border-radius: 24px;
  transition: all 0.5s ease;
}

.countdown-wrapper:hover .glow-effect {
  transform: scale(1.1);
}

.purple-glow { background: #9333ea; }
.pink-glow { background: #ec4899; }
.orange-glow { background: #f97316; }
.red-glow { background: #ef4444; }

.countdown-border {
  position: relative;
  padding: 4px;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.purple-border { background: linear-gradient(135deg, #9333ea, #a855f7); }
.pink-border { background: linear-gradient(135deg, #ec4899, #f472b6); }
.orange-border { background: linear-gradient(135deg, #f97316, #fb923c); }
.red-border { background: linear-gradient(135deg, #ef4444, #f87171); }

.countdown-inner {
  border-radius: 22px;
  padding: 2rem 1.5rem;
  min-width: 120px;
}

.gradient-number {
  background: linear-gradient(135deg, #9333ea 0%, #ec4899 50%, #f97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 4rem;
}

.label-text {
  font-size: 1.125rem;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.15em;
}

/* Floating Animation */
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.floating-1 {
  animation: float 3s ease-in-out infinite;
}

.floating-2 {
  animation: float 3s ease-in-out infinite 0.3s;
}

.floating-3 {
  animation: float 3s ease-in-out infinite 0.6s;
}

.floating-4 {
  animation: float 3s ease-in-out infinite 0.9s;
}

/* Pulse Dots */
.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
}

.purple-dot { background: #9333ea; }
.pink-dot { 
  background: #ec4899;
  animation-delay: 0.3s;
}
.orange-dot { 
  background: #f97316;
  animation-delay: 0.6s;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
}

/* Responsive */
@media (max-width: 767px) {
  .gradient-number {
    font-size: 3rem;
  }
  
  .countdown-inner {
    padding: 1.5rem 1rem;
    min-width: 100px;
  }
  
  .gradient-title {
    font-size: 2.5rem;
  }
  
  .label-text {
    font-size: 1rem;
  }
}

@media (min-width: 992px) {
  .countdown-inner {
    padding: 2.5rem 2rem;
    min-width: 150px;
  }
  
  .gradient-number {
    font-size: 5rem;
  }
}
</style>